module.exports = __webpack_public_path__ + "static/media/accessibility-dark.f43081ea.svg";